export default __webpack_public_path__ + "static/media/Mastercard.f9abe71c.svg";